// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CompanyTransactionsTableView_tableWrapper__GqINc","checkedStatus":"CompanyTransactionsTableView_checkedStatus__GzsRf"};